import { AlertTriangle } from '../../../../icons';

export function ManualReviewBanner({ reasons }: { reasons: string[] }) {
  return (
    <div className="mx-4 mt-4 flex gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-body-sm-regular text-amber-900">
      <AlertTriangle size={18} className="mt-0.5 shrink-0 text-amber-500" />
      <div>
        <p className="font-semibold">Manual review required</p>
        {reasons.length > 0 ? (
          <ul className="mt-1 list-disc pl-4 text-caption-regular leading-relaxed">
            {reasons.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        ) : (
          <p className="mt-1 text-caption-regular">Review before approval.</p>
        )}
      </div>
    </div>
  );
}
